module.exports = __webpack_public_path__ + "a965131d00a8e3d434b8bf42c90c608e.woff";